// src/icons/TriangleArrowDownIcon.tsx
import { jsx, jsxs } from "react/jsx-runtime";
function TriangleArrowDownIcon({
  title,
  titleId,
  ...props
}) {
  return /* @__PURE__ */ jsxs("svg", {
    "aria-hidden": "true",
    "aria-labelledby": titleId,
    fill: "currentColor",
    viewBox: "0 0 6 10",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", {
        id: titleId,
        children: title
      }) : null,
      /* @__PURE__ */ jsx("path", {
        d: "M3 10L5.88675 5L0.113249 5L3 10ZM2.5 2.18557e-08L2.5 5.5L3.5 5.5L3.5 -2.18557e-08L2.5 2.18557e-08Z",
        fill: "current"
      })
    ]
  });
}
export {
  TriangleArrowDownIcon
};
//# sourceMappingURL=TriangleArrowDownIcon.mjs.map